import { render, staticRenderFns } from "./other_info.vue?vue&type=template&id=127c87a8"
import script from "./other_info.vue?vue&type=script&lang=js"
export * from "./other_info.vue?vue&type=script&lang=js"
import style0 from "./other_info.vue?vue&type=style&index=0&id=127c87a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports